import * as React from 'react';
import { connect } from 'react-redux';
import withCountryCode from '../../components/RoutesHoc/RoutesHoc';
import { home } from '../../helpers/routes';
import { OverflowingImage, ShopAnchor } from '../components/AboutUs';
import {
  AboutUsWelcome,
  AboutUsAfterItalist,
  AboutUsBeforeItalist,
  AboutUsInsiders,
  AboutUsLearnMore,
  AboutUsVideo
} from '../../components_common/AboutUs';
import { AboutUsWrapper } from '../../components_common/AboutUs/styled';
import VerticalSpacer from '../../components_common/VerticalSpacer';
import Store from '../../common/models/Store';

const mapStateToProps = ({ api: { s3BasePath } }: Store) => ({
  s3BasePath
});

const AboutUsComponent: React.ComponentType<{
  buildUrlWithCountry: (route: string) => string;
  s3BasePath: string;
}> = ({ buildUrlWithCountry, s3BasePath }) => (
  <AboutUsWrapper>
    <VerticalSpacer height="30px" />
    <AboutUsWelcome />
    <VerticalSpacer height="40px" />
    <AboutUsInsiders />
    <VerticalSpacer height="40px" />
    <AboutUsBeforeItalist />
    <VerticalSpacer height="30px" />
    <OverflowingImage src={`${s3BasePath}about_us/milan_mobile.png`} widthFraction={1} />
    <VerticalSpacer height="20px" />
    <AboutUsAfterItalist />
    <VerticalSpacer height="30px" />
    <OverflowingImage src={`${s3BasePath}about_us/mock_mobile.png`} widthFraction={0.92} />
    <VerticalSpacer height="14px" />
    <AboutUsLearnMore />
    <VerticalSpacer height="60px" />
    <AboutUsVideo />
    <VerticalSpacer height="60px" />
    <ShopAnchor href={buildUrlWithCountry(home)} margin="0 5%" width="90%">
      SHOP NOW
    </ShopAnchor>
    <VerticalSpacer height="60px" />
  </AboutUsWrapper>
);

const AboutUs = connect(mapStateToProps)(AboutUsComponent);
export default withCountryCode(AboutUs);
